import videojs from 'video.js';

const Component = videojs.getComponent('Component');

import './AdInfoContainer.js';
import './AdTimelineContainer.js';
import './AdPreSkip.js';


export default class AdsUI extends Component {

    constructor(player, options) {
        super(player, options)
    }

    createEl() {
	    return super.createEl('div', {
	      className: 'vjs-ads-container',
	      dir: 'ltr'
	    });
	}
}

AdsUI.prototype.options_ = {
  children: [
    'adInfoContainer',
    'adTimelineContainer',
    'adPreSkip'
  ]
};

Component.registerComponent('AdsUI', AdsUI);
